window.app = window.app || {};
window.app.cw = window.app.cw || {};
window.app.cw.common = window.app.cw.common || {};

// ----------------------------- Notification Widget ----------------------------- //
app.cw.common.Notification = {
    show: function showNotification(title, message, type) {
        var notificationWidget = $('#notification').data('kendoNotification');
        var existingNotifications = notificationWidget.getNotifications();

        if (existingNotifications.length) { // if there are notifications, remove existing notification
            app.cw.common.Notification.remove();
        }

        message = message ? message : "";
        notificationWidget.show({ title: title, message: message }, type);
    },
    remove: function removeNotification() {
        var notificationWidget = $('#notification').data('kendoNotification');
        var existingNotifications = notificationWidget.getNotifications();

        // remove existing notifications
        existingNotifications.each(function () {
            $(this).closest('.k-animation-container').remove();
        });
    },
    displaySuccess: function displaySuccess(message) {
        title = typeof title !== 'undefined' ? title : 'Success';
        app.cw.common.Notification.show(title, message, 'success');
    },
    displayWarning: function displayWarning(message) {
        title = typeof title !== 'undefined' ? title : 'Warning';
        app.cw.common.Notification.show(title, message, 'warning');
    },
    displayError: function displayError(message, title) {
        title = typeof title !== 'undefined' ? title : 'Error';
        app.cw.common.Notification.show(title, message, 'error');
    },
    displayModelStateErrors: function (errors, title) {
        title = typeof title !== 'undefined' ? title : 'Error';
        const markup = app.cw.common.Notification.getMsgMarkup(errors);
        app.cw.common.Notification.show(title, markup, 'error');
    },
    getMsgMarkup: function (msgs) {
        let markup = '<ul>';
        $.each(msgs, function (i, msg) {
            markup += '<li>' + msg + '</li>';
        });
        markup += '</ul>';
        return markup;
    },
    onShowNotification: function onShowNotification(e) {
        // center notification on screen
        if (!$("." + e.sender._guid)[1]) {
            var element = e.element.closest('.k-animation-container'),
                eWidth = element.width(),
                eHeight = element.height(),
                wWidth = $(window).width(),
                wHeight = $(window).height(),
                newTop, newLeft;

            newLeft = Math.floor(wWidth / 2 - eWidth / 2);
            newTop = Math.floor(wHeight / 2 - eHeight / 2);

            e.element.closest('.k-animation-container').css({ left: newLeft });
        }

        // allow modal to still be scrollable when notification shows
        setTimeout(function () {
            if ($('.modal.show').length) {
                $(document.body).addClass('modal-open');
            }
        }, 1000);
    }
};